import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuGroup,
  Button,
  Icon,
  Box,
} from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Tags, ChevronDown, X } from 'lucide-react';
import { useMemo } from 'react';

import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { iconSize, menuMaxHeight } from '@duke-hq/ui/constants/scalable';

type Props = {
  providers: Array<{ id: string; name: string }>;
};

export function ProviderFilter({ providers }: Props) {
  const { updateFilters, filters } = useFiltersContext();

  const filterLabel = useMemo(() => {
    if (filters.studentOnly === 'true') {
      return t`Student Support`;
    }

    if (filters.provider !== undefined) {
      const provider = providers.find(({ id }) => id === filters.provider?.toString());
      return provider ? provider.name : t`Provider`;
    }

    return t`All Tickets`;
  }, [filters.studentOnly, filters.provider, providers]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        leftIcon={<Icon as={Tags} boxSize={4} />}
        rightIcon={
          filters.provider !== undefined || filters.studentOnly !== undefined ? (
            <Box
              minW="fit-content"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                updateFilters({ provider: undefined, studentOnly: undefined });
              }}
              ml={1}
            >
              <X size={iconSize.md} />
            </Box>
          ) : (
            <ChevronDown size={iconSize.md} />
          )
        }
        variant="ghost"
        size="sm"
        fontWeight="normal"
        px={3}
      >
        {filterLabel}
      </MenuButton>
      <MenuList maxH={menuMaxHeight} overflowY="auto">
        <MenuItem onClick={() => updateFilters({ provider: undefined, studentOnly: undefined })}>
          <Trans>All Tickets</Trans>
        </MenuItem>
        <MenuItem onClick={() => updateFilters({ provider: undefined, studentOnly: 'true' })}>
          <Trans>Student Support</Trans>
        </MenuItem>
        {providers.length > 0 && (
          <MenuGroup color="gray.400" title="PROVIDERS">
            {providers.map((provider) => (
              <MenuItem
                key={provider.id}
                onClick={() =>
                  updateFilters({ provider: parseInt(provider.id), studentOnly: undefined })
                }
                fontWeight={filters.provider?.toString() === provider.id ? 600 : 'normal'}
                bg={filters.provider?.toString() === provider.id ? 'bg.emphasis' : undefined}
              >
                {provider.name}
              </MenuItem>
            ))}
          </MenuGroup>
        )}
      </MenuList>
    </Menu>
  );
}
